module.exports = __webpack_public_path__ + "mainassets/img/about-us0.ea5e37ec.jpg";